export const DATA_TYPE = {
    MATCH: 'match',
    SEASON_AVERAGES: 'season averages'
};
